import { LoadableBackground } from '@confluence/loadable';

export const CoreInvitesLoadable = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CoreInvites" */ './CoreInvites.tsx')).CoreInvites,
});
